import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Fragment = makeShortcode("Fragment");
const Content = makeShortcode("Content");
const ContentColumns = makeShortcode("ContentColumns");
const Card = makeShortcode("Card");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Fragment mdxType="Fragment">
      <Content mdxType="Content">
        <h2>{`A Dream Fulfilled and Our Beginnings`}</h2>
        <blockquote>
          <p parentName="blockquote">{`It’s our dream come true. I’m a native of Vernár and have been involved with the Vernár ski resort since childhood. This is where I learned to ski, and this region is very close to my heart. That’s why my family and I decided to open a restaurant here. Later, we expanded our plans and decided to open a hotel.`}</p>
          <footer>Ján Alexa Sr., head of the family.</footer>
        </blockquote>
        <p>{`Our family handled much of the construction work ourselves—we have experience in building. Every piece, every corner of the hotel reflects our work and the heart we put into it.`}</p>
        <p>{`In the winter of 2016, we made the decision. Although the accommodation section and the exterior facade weren’t fully finished, we opened the restaurant. During the 2016/2017 ski season, we welcomed and served our first guests—and there were many :)`}</p>
        <p>{`After the ski season, it was time to finish the remaining construction. The next season belonged not only to the restaurant but also to the hotel. In the winter of 2017, we welcomed our first overnight guests.`}</p>
        <p>{`Our hotel Studničky is a family-run hotel into which we’ve poured our soul, and we believe that every guest will feel the warmth and family atmosphere.`}</p>
        <h2>{`Hotel Amenities`}</h2>
        <ul>
          <li parentName="ul">{`14 hotel rooms and suites with a total capacity of 40 guests`}</li>
          <li parentName="ul">{`Restaurant with a capacity of 100 guests`}</li>
          <li parentName="ul">{`Conference room with a capacity of 50 guests`}</li>
          <li parentName="ul">{`Ski equipment rental and storage directly in the hotel`}</li>
          <li parentName="ul">{`Kids’ play area and board games available at the reception`}</li>
          <li parentName="ul">{`Outdoor whirlpool`}</li>
        </ul>
      </Content>
      <h2>{`They Wrote About Us`}</h2>
      <ContentColumns mdxType="ContentColumns">{[<Card key={1} image="restauracia/restauracia.jpg" title="Vo Vernári otvorili reštauráciu Studničky plnú domácich lahôdok" to="https://magazin.lionline.sk/vo-vernari-otvorili-restauraciu-studnicky-plnu-domacich-lahodok/" mdxType="Card">
		Novootvorená reštaurácia Studničky v malebnej obci Vernár ponúka chutnú domácu kuchyňu ako od babičky.
	</Card>, <Card key={2} image="hotel/studnicky.jpg" title="Sedem dôvodov, prečo navštíviť rodinný hotel Studničky vo Vernári" to="https://magazin.lionline.sk/sedem-dovodov-preco-navstivit-rodinny-hotel-studnicky-vo-vernari/" mdxType="Card">
		Zabudnite na každodenné starosti a navštívte výnimočný domáci hotel Studničky nachádzajúci sa v lone krásnej prírody Slovenského Raja.
	</Card>, <Card key={3} image="hotel/IMG_5057.jpg" title="Okolie hotela Studničky láka mnoho turistov aj počas letnej sezóny" to="https://magazin.lionline.sk/okolie-hotela-studnicky-laka-mnoho-turistov-aj-pocas-letnej-sezony/" mdxType="Card">
		Okolie hotela Studničky ponúka veľké množstvo lákadiel, ktoré ocenia najmä vyznávači turistiky či spoznávania krás Slovenska.
	</Card>]}</ContentColumns>
    </Fragment>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      